export default __webpack_public_path__ + "static/media/down-arrow.30a90f95.svg";